import Logger from 'loglevel';
import { isDevEnv } from '../../config/settings/environments';

Logger.setLevel(isDevEnv ? Logger.levels.DEBUG : Logger.levels.WARN);

export default Logger;
